import React, { useState } from "react";
import {
  Box,
  Button,
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import moment from "moment";

const predefinedRanges = [
  {
    label: "Today",
    getRange: () => ({
      startDate: new Date(),
      endDate: new Date(),
    }),
  },
  {
    label: "Last 7 Days",
    getRange: () => ({
      startDate: moment().subtract(7, "days").toDate(),
      endDate: new Date(),
    }),
  },
  {
    label: "Last 30 Days",
    getRange: () => ({
      startDate: moment().subtract(30, "days").toDate(),
      endDate: new Date(),
    }),
  },
  {
    label: "Last Year",
    getRange: () => ({
      startDate: moment().subtract(1, "year").toDate(),
      endDate: new Date(),
    }),
  },
];

const DateRangePicker = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  onSearch,
  loading,
}) => {
  const [selectedRange, setSelectedRange] = useState("");

  const handlePredefinedRangeChange = (event) => {
    const rangeLabel = event.target.value;
    setSelectedRange(rangeLabel);
    if (rangeLabel) {
      const range = predefinedRanges.find((r) => r.label === rangeLabel);
      if (range) {
        const { startDate, endDate } = range.getRange();
        onStartDateChange(startDate);
        onEndDateChange(endDate);
      }
    }
  };

  return (
    <Box
      sx={{
        gap: 1,
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        justifyContent: "flex-end",
      }}
    >
      <FormControl size="small" sx={{ minWidth: 120, maxWidth: 160 }}>
        <InputLabel>Range</InputLabel>
        <Select
          value={selectedRange}
          onChange={handlePredefinedRangeChange}
          label="Range"
          size="small"
        >
          <MenuItem value="">
            <em>Custom</em>
          </MenuItem>
          {predefinedRanges.map((range) => (
            <MenuItem key={range.label} value={range.label}>
              {range.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <DatePicker
        value={startDate}
        onChange={onStartDateChange}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Start Date"
            size="small"
            sx={{ width: 160 }}
          />
        )}
      />
      <DatePicker
        value={endDate}
        onChange={onEndDateChange}
        renderInput={(params) => (
          <TextField
            {...params}
            label="End Date"
            size="small"
            sx={{ width: 160 }}
          />
        )}
      />

      <Button
        variant="contained"
        size="medium"
        onClick={onSearch}
        disabled={!startDate || !endDate || loading}
        sx={{ minWidth: "auto", px: 3 }}
      >
        Search
      </Button>
    </Box>
  );
};

export default DateRangePicker;
